export default class AppWalkthrough {
  constructor() {
    this.$el = document.querySelector('.c-app-walkthrough__inner');
    if (!this.$el) return;

    // DOM
    this.$svg = document.getElementById('app-walkthrough-line');
    this.$purpleLine = document.getElementById('app-walkthrough-purple-line');
    this.$circle = document.getElementById('app-walkthrough-circle');
    this.$metric = document.querySelector('.c-metric');
    this.$phones = document.querySelectorAll('.c-app-walkthrough__item');

    // Vars
    this.purpleLinelength = this.$purpleLine.getTotalLength();
    this.finished = false;

    // Initial state
    this.$purpleLine.style.strokeDasharray = this.purpleLinelength;
    this.$purpleLine.style.strokeDashoffset = this.purpleLinelength;

    // Dash array offset where the dot intersects each phone
    this.waypoints = [3746, 2394, 1021];

    // Events
    window.addEventListener('scroll', this.draw.bind(this));
  }

  /**
   * @function draw
   * Draws the purple line and circle positions
   */
  draw() {
    if (this.finished) return;

    const viewportTop = document.body.scrollTop + document.documentElement.scrollTop;
    const componentRect = this.$el.getBoundingClientRect();
    const componentPageOffsetY = componentRect.top + viewportTop;
    const viewportHeight = window.innerHeight;
    const halfViewportHeight = viewportHeight / 2;
    const componentViewportScroll = Math.min(1, Math.max(0, (viewportTop - componentPageOffsetY + halfViewportHeight) / componentRect.height));
    const draw = this.purpleLinelength * componentViewportScroll;
    const offset = this.purpleLinelength - draw;

    // Update the offset
    this.$purpleLine.style.strokeDashoffset = offset;

    // Update the active phone
    this.updatePhones(offset);
    this.updateCircle(draw);

    if (componentViewportScroll >= 1) {
      this.onFinish();
    }
  }

  /**
   * @function updatePhones
   * @param {Number} offset
   * Sets the phone to active depending on the waypoint
   */
  updatePhones(offset) {
    this.waypoints.forEach((waypoint, i) => {
      if (offset <= waypoint) {
        this.$phones[i].dataset.dispatched = true;
      }
    });
  }

  /**
   * @function updateCircle
   * @param {Number} draw
   * Updates the circle position relative to the path
   */
  updateCircle(draw = 0) {
    const point = this.$purpleLine.getPointAtLength(draw);
    this.$circle.setAttribute('cx', point.x);
    this.$circle.setAttribute('cy', point.y);
  }

  /**
   * @function onFinish
   * Fired when the line drawing is finished
   */
  onFinish() {
    this.finished = true;
    this.$purpleLine.style.strokeDashoffset = 0;
    this.$circle.classList.remove('is-visible');
    this.$metric.classList.add('is-active');
  }
}
